query LinksAutocomplete(
  $input: String
  $value: [ID!]
  $filter: AutocompleteLinksFilterInput
) {
  autocomplete: autocompleteLinks(input: $input, value: $value, filter: $filter) {
    value {
      value
      label
      subtitle
    }
    options {
      value
      label
      subtitle
    }
  }
}
